import React from 'react'
import styled from 'styled-components'
import { mobileBreakPoint } from 'app.styled/media'

type TProps = {
  searchKeyword: string
}

const SearchResultNotFound: React.FC<TProps> = ({ searchKeyword }) => {
  return (
    <StyledWrapper>
      <h4 className="not-found-message">
        <span style={{ color: '#01a0ff' }}>{searchKeyword}</span> 에 대한
        검색결과가 없습니다.
      </h4>
      <p className="search-tip">
        단어의 철자가 정확한지 확인하세요.
        <br /> 다른 검색어를 사용해보세요.
        <br /> 더 일반적인 검색어를 사용해 보세요.
      </p>
    </StyledWrapper>
  )
}

export default SearchResultNotFound

const StyledWrapper = styled.div`
  margin: auto;
  padding: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  text-align: center;
  .not-found-message {
    color: #333;
    font-weight: 500;
    font-size: 20px;
    margin-bottom: 10px;
  }
  .search-tip {
    font-size: 16px;
    color: #999;
  }
  ${mobileBreakPoint} {
    padding: 44px 0;
    background-color: #fff;
    border-bottom: 1px solid #e8e8e8;
    .not-found-message {
      font-size: 16px;
    }
    .search-tip {
      font-size: 12px;
      color: #999;
    }
  }
`
